module.exports = __webpack_public_path__ + "static/media/heat-exchanger-log.e68ba74f.mp3";